import moment from "moment";

export const formatDate = function (value, formate = "MM/DD/YYYY") {
  return moment(value).local().format(formate);
};
